var map = {
	"./1-1-p3.svg": "2adf",
	"./1-2-p3.svg": "d2bf",
	"./1-3-p3.svg": "cdc9",
	"./1-4-p3.svg": "cdd2",
	"./1-5-p3.svg": "39b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "71c3";